import { render, staticRenderFns } from "./DadosContrato.vue?vue&type=template&id=ec4dea64"
import script from "./DadosContrato.vue?vue&type=script&lang=js"
export * from "./DadosContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports